import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";
import DesignBoxNavigationCrumb from "../../Reusables/DesignBoxNavigationCrumb";
import styles from "./CompleteSubmission.module.css";
import EditScreenItemHeaderDiv from "../EditScreenItemHeaderDiv";
import EditScreenCompleteSubmissionHeaderInfoDiv from "./EditScreenCompleteSubmissionHeaderInfoDiv";

export default function CompleteSubmission() {
  const [productName, setProductName] = useState(null);
  const [title, setTitle] = useState(null);
  const [count, setCount] = useState(null);
  const [address, setAddress] = useState(null);
  const [item, setItem] = useState(null);
  const stateData = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let data = stateData.state;
    setTitle(data.title);
    setProductName(data.subtitle);
    setCount(data.count);
    setAddress(data.address);
    setItem(data.item);
  }, []);

  const handleRedirect = () => {
    navigate("/design-box");
  };

  return (
    <>
      <Header />
      <div className={styles.edit_screen_main_div}>
        <DesignBoxNavigationCrumb
          active={4}
          showFifth={true}
          fourthText={"入稿完了"}
        />
        <EditScreenItemHeaderDiv
          title={title}
          subtitle={productName}
          count={count}
          address={address}
          item={item}
        />
        <EditScreenCompleteSubmissionHeaderInfoDiv
          lines={[
            "デザイン入稿しました。",
            "完成デザイン画像ができましたらご登録のメールへお知らせいたします。",
            "必ず7日以内に「修正希望」もしくは「デザイン確定」のボタンを押してお知らせください。",
            "7日以内にご連絡がない場合は、変更はできませんのでご了承ください。",
          ]}
        />
        <div className={styles.confirm_edits_wrapper}>
          <div className={styles.confirm_edits}>
            <div className={styles.confirm_header}>
              別のアイテムを編集する場合はこちら
            </div>
            <div className={styles.confirm_button_section}>
              <button
                onClick={handleRedirect}
                className={styles.confirm_button_yes}
              >
                アイテムを編集する
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
